/* ==========================================================================
   ButtonRxjs > Client > Prototype
   ========================================================================== */

/* Modules */
const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');

const { Store } = require('@bluekiri/alexandria/helpers/state');
const { fromEvent } = require('rxjs');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { initLoader, destroyLoader } = require('./loader');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            button: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            setContent: content => this.store.dispatch(actions.setContent(content)),
            setIcon: icon => this.store.dispatch(actions.setIcon(icon)),
            destroy: () => this.store.dispatch(actions.destroy()),
            disable: () => this.store.dispatch(actions.disable()),
            display: () => this.store.dispatch(actions.display()),
            enable: () => this.store.dispatch(actions.enable()),
            hide: () => this.store.dispatch(actions.hide())
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            setContent: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_CONTENT) return;

                const { context } = this.config;
                const { markdown } = ViewHelpers(context);

                if (this.hooks.content) {
                    this.hooks.content.innerHTML = markdown(`${action.payload}`);
                }
            }),
            setIcon: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_ICON) return;

                if (this.hooks.icon) {
                    this.hooks.icon.className = '';
                    this.hooks.icon.className = `nico-${action.payload}`;
                }
            }),
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Loader */
                destroyLoader(this);

                /* Remove element */
                this.element.parentNode.removeChild(this.element);

                /* Clean */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            disable: this.store.subscribe((state, action) => {
                if (action.type !== types.DISABLE) return;

                this.element.classList.add(this.config.css.disable);
                this.element.setAttribute('disabled', '');
            }),
            display: this.store.subscribe((state, action) => {
                if (action.type !== types.DISPLAY) return;

                this.element.classList.remove(this.config.css.hidden);
            }),
            enable: this.store.subscribe((state, action) => {
                if (action.type !== types.ENABLE) return;

                this.element.classList.remove(this.config.css.disable);
                this.element.removeAttribute('disabled');
            }),
            hide: this.store.subscribe((state, action) => {
                if (action.type !== types.HIDE) return;

                this.element.classList.add(this.config.css.hidden);
            })
        };

        return this;
    },
    /* Setup events */
    setupEvents() {
        if (!this.config.events) return this;

        this.events = {
            click$: fromEvent(this.element, 'click')
        };

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        /* Check for auto disabled from render */
        const { disabled, content } = this.config;

        if (!disabled) {
            return this;
        }

        if (content) {
            this.actions.setContent(content);
        }

        /* Disable */
        this.actions.disable();

        return this;
    },
    /* Init */
    init() {
        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Setup events */
        this.setupEvents();

        /* Loader */
        initLoader(this);

        /* Start */
        this.start();
    }
};

/* Exports */
module.exports = prototype;
